export const UNITS_FILTER_OPTIONS_KEY = "UNITS_FILTER_OPTIONS";
export const UNITS_NEEDS_LOCKBOX_COUNT_KEY = "UNITS_NEEDS_LOCKBOX_COUNT";
export const UNIT_MARK_VIEWED_KEY = "UNIT_MARK_VIEWED";
export const UNIT_MARK_ACTIVITY_READ_KEY = "UNIT_MARK_ACTIVITY_READ";
export const UNIT_INSTRUCTION_TARGETS_KEY = "UNIT_INSTRUCTION_TARGETS";
export const UNIT_INSTRUCTIONS_UPDATE_KEY = "UNIT_INSTRUCTIONS_UPDATE";
export const UNIT_INSTRUCTIONS_APPLY_KEY = "UNIT_INSTRUCTIONS_APPLY";
export const UNIT_INSTRUCTION_BULK_APPLY_KEY = "UNIT_INSTRUCTION_BULK_APPLY";
